import React, { useState, useCallback, useEffect, useMemo } from 'react';
import { ApptCust, Customer, SpecData, UpdateApptCustInp, VehicleRec, ascCtaInteractionInput, ascFormEngagementInput, ascFormSubmissionInput, ascPageviewInput } from 'src/models';
import { strings } from 'src/localization';
import { IView } from 'Framework';
import { IconHelpCircle, IconHelpCircleAlt, IconRemove } from 'src/content/icons';
// import { getStatesDropDownList, getStateName } from '@reynolds/statelisthelper';
import { getStateOrProvinceDropDownList, getStateOrProvinceName } from 'src/helpers/StateProvinceHelper/StateProvinceHelper';
import { Checkbox, TextField, Dialog, IconButton, IDropDownItem, SelectList, ScrollBar, LoadingProgress } from '@framework-controls/core';
import classNames from 'classnames';
import Footer from '../Footer/Footer';
import css from './ViewAccount.module.scss';
import SVPButton from '../SVPButtons/SVPButton';
import { checkCustUpdateEmail } from 'src/helpers/DepartmentHelper/DepartmentHelper';
import ErrorMessage from '../ErrorMessage/ErrorMessage';
import RecordLockError from '../RecordLockError/containers/RecordLockError';
import { ComponentMapIds } from '../map';
import { ascCtaInteraction, ascFormEngagement, ascFormSubmission, ascPageview, getElementColor } from 'src/helpers/EventHelper/EventHelper';

// const customButtons: IFormButton[] = [
//     { label: 'NO', value: 'no', color: 'secondary', variant: 'secondaryBtnAlt'},
//     { label: 'YES', value: 'yes', color: 'primary', variant: 'primaryBtnAlt'},
// ];

const emailRegex = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))/.source +
    /@/.source +
    /((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.source);

export interface IProps {
    popFromMainPane: (id: string) => void;
    changeCustInfo: (cust: Customer, profileNum, store: string, branch: string, previewFlag: string) => void;
    setChangeCustReturned: (value: boolean) => void;
    checkPhoneOptIn: (custId: string, profileNum: string, store: string, branch: string) => void;
    clearTextCheckReturned: () => void;
    clearError: () => void;
    checkUniqueEmail: (email: string, nameId: string, profileNum: string, store: string, branch: string,
        firstName: string, lastName: string, phone: string) => void;
    textCheckReturned?: boolean;
    mainPaneViewOrder?: IView[];
    customerInfo?: Customer;
    specData?: SpecData;
    locale: string;
    onCustUpdate: (cust: Customer) => void;
    specProfile: string;
    store: string;
    branch: string;
    previewFlag: string;
    theme: string;
    errMsg?: string;
    retCode?: string;
    changeCustReturned: boolean;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
    addLogEntry: (action: string, screen: string, details: string) => void;
    apptCust: ApptCust;
    countryCode: string;
    onApptCustUpdate: (apptCust: UpdateApptCustInp) => void;
}

const ViewAccount = (props: IProps) => {
    const { customerInfo } = props;
    const initialFirstName = customerInfo!.firstName;
    const initialLastName = customerInfo!.lastName;
    const initialEmail = customerInfo!.emailAddress;
    const initialTextOpt = customerInfo!.textOptIn;
    const initialEmailOpt = customerInfo!.emailOptIn;
    const initialPhone = customerInfo!.phoneNumber;
    const initialStreet = customerInfo!.streetAddress;
    const initialCity = customerInfo!.city;
    const initialStateAddress = customerInfo!.stateAddress;
    const initialZipCode = customerInfo!.zipCode;

    const [firstName, setFirstName] = useState(initialFirstName);
    const [lastName, setLastName] = useState(initialLastName);
    const [email, setEmail] = useState(props.apptCust?.custEmailAddress ? props.apptCust?.custEmailAddress : initialEmail);
    const [phoneNumber, setPhoneNumber] = useState(initialPhone);
    const [street, setStreet] = useState(initialStreet);
    const [city, setCity] = useState(initialCity);
    const [stateAddress, setStateAddress] = useState<string>((initialStateAddress));
    const [zipCode, setZipCode] = useState(initialZipCode);
    const [editMode, setEditMode] = useState(false);
    const [emailOpt, setEmailOpt] = useState(false);
    const [phoneOpt, setPhoneOpt] = useState(false);
    const [onEntry, setOnEntry] = useState(true);
    const [dialogActive, setDialogActive] = useState(false);
    const [displayHelpMessage, setDisplayHelpMessage] = useState(false);
    const [zipError, setZipError] = useState(false);
    const [stateList, setStateList] = useState<IDropDownItem[]>([]);
    const [optedOutViaText, setOptedOutViaText] = useState(false);
    const [optInFail, setOptInFail] = useState(false);
    const [fieldError, setFieldError] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const [errorUpdateFlag, setErrorUpdateFlag] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [checkingOpt, setCheckingOpt] = useState(false);
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastNameError, setLastNameError] = useState(false);
    const [emailErrorMsg, setEmailErrorMsg] = useState('');
    const [streetError, setStreetError] = useState(false);
    const [cityError, setCityError] = useState(false);
    const [selectListKey, setSelectListKey] = useState<number>(0);
    // useEffect(() => {
    // const flyoutContent = document.getElementById('StateEdit_input-label');
    // if (flyoutContent) {
    //     flyoutContent.style.setProperty('font-size', '1.34rem');
    //     flyoutContent.style.setProperty('font-family', 'inherit');
    //     flyoutContent.style.setProperty('white-space', 'pre-wrap');
    //     flyoutContent.style.setProperty('color', 'inherit');
    // }
    // });

    useEffect(() => {
        props.addLogEntry('Screen Entry', 'View Account', '');
    }, [
        props.addLogEntry,
    ]);

    let helpDisplay = css.helpDisplay;
    let helpDisplayMini = css.helpDisplayNone;
    if (props.theme === 'mini') {
        helpDisplay = css.helpDisplayNone;
        helpDisplayMini = css.helpDisplay;
    }
    if (!editMode) {
        helpDisplay = css.helpDisplayNone;
        helpDisplayMini = css.helpDisplayNone;
    }

    // shows/hides a help message upon clicking the question mark button for phone opt in
    const onHelpClick = useCallback((e: any) => {
        setDisplayHelpMessage(!displayHelpMessage);
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: '?',
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'information_link',
            eventAction: 'click',
            eventActionResult: 'open',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [displayHelpMessage, props.vehicles, props.selectedVehicle]);

    useEffect(() => {
        if (customerInfo) {
            props.checkPhoneOptIn(customerInfo?.nameId, props.specProfile, props.store, props.branch);
        }
    }, [customerInfo, props.branch, props.specProfile, props.store, props.checkPhoneOptIn]);

    if (onEntry) {
        if (initialEmailOpt === 'Y') {
            setEmailOpt(true);
        }
        if (initialTextOpt === 'I') {
            setPhoneOpt(true);
        }
        if (initialTextOpt === 'T') {
            setOptedOutViaText(true);
        }
        // get the list of states/provinces
        setStateList(getStateOrProvinceDropDownList(props.locale));
        setOnEntry(false);
    }

    useEffect(() => {
        setStateList(getStateOrProvinceDropDownList(props.locale));
    }, [props.locale]);

    /* After the stateList is updated we check the current stateAddress against it.
       If we do not find a match we set the stateAddress equal to the first value, which is ''.
       Lastly we update the selectListKey to force the component to update.
    */
    useEffect(() => {
        if (stateList.length > 0 && editMode) {
            const exist = stateList.find(state => (state.value === stateAddress));
            if (!exist) {
                setStateAddress(stateList[0].value);
            }
        }
        setSelectListKey(prev => prev +1);
    }, [editMode, initialStateAddress, stateAddress, stateList]);

    useEffect(() => {
        if (props.customerInfo?.textOptIn === 'T') {
            setOptedOutViaText(true);
            setPhoneOpt(false);
        } else {
            setOptedOutViaText(false);
        }
    }, [props.customerInfo]);

    useEffect(() => {
        const unformattedInitial = initialPhone?.replace(/[^0-9]/g, '') ?? '';
        const masked = initialPhone?.includes('*');

        if (unformattedInitial?.length !== 10 && editMode && !masked) {
            setPhoneError(true);
        }
    }, [editMode, initialPhone]);

    useEffect(() => {
        if (props.mainPaneViewOrder){
            if (props.mainPaneViewOrder[props.mainPaneViewOrder.length - 1]?.viewId === ComponentMapIds.ViewAccount) {
                const ascPageViewInp: ascPageviewInput = {
                    pageType: 'contact',
                    errorCode: '',
                    itemResults: '',
                };
                ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
            }
        }
    }, [props.mainPaneViewOrder, props.vehicles, props.selectedVehicle]);

    const onBlurHandler = useCallback((id) => {
        let elementText = '';
        switch (id) {
            case 'FirstNameEdit':
                elementText = strings.FirstName;
                break;
            case 'LastNameEdit':
                elementText = strings.LastName;
                break;
            case 'EmailEdit':
                elementText = strings.EmailAddress;
                break;
            case 'PhoneEdit':
                elementText = strings.PhoneNumber;
                break;
            case 'StreetEdit':
                elementText = strings.StreetAddress;
                break;
            case 'CityEdit':
                elementText = strings.City;
                break;
            case 'ZipCodeEdit':
                elementText = strings.ZipCode;
                break;
            case 'StateEdit':
                elementText = strings.State;
                break;
            default:
                elementText = '';
                break;
        }
        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'contact',
            commType: 'form',
            commStatus: 'engage',
            elementText: elementText,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle]);

    // handles edits to the fields
    const onChangeHandler = useCallback((id: string, value: string, error?: boolean) => {
        let formattedValue = value.replace(/[^0-9]/g, '');
        switch (id) {
            case 'FirstNameEdit':
            default:
                if ((value + lastName).length < 36) {
                    setFirstNameError(false);
                    if (lastNameError) {
                        setLastNameError(false);
                    }
                } else {
                    setFirstNameError(true);
                    setLastNameError(true);
                }
                setFirstName(value);
                break;

            case 'LastNameEdit':
                if ((value + firstName).length < 36) {
                    setLastNameError(false);
                    if (firstNameError) {
                        setFirstNameError(false);
                    }
                } else {
                    setLastNameError(true);
                    setFirstNameError(true);
                }
                setLastName(value);
                break;

            case 'EmailEdit':
                if (value.match(emailRegex) && value.length < 63) {
                    setEmailError(false);
                } else {
                    if (value.length > 62) {
                        setEmailErrorMsg(strings.ValidEmailLength);
                    } else {
                        setEmailErrorMsg(strings.ValidEmail);
                    }
                    setEmailError(true);
                }
                setEmail(value);
                break;

            case 'PhoneEdit':
                if (formattedValue.length === 10) {
                    formattedValue = `(${formattedValue.slice(0, 3)}) ${formattedValue.slice(3, 6)}-${formattedValue.slice(6)}`;
                    setPhoneError(false);
                } else {
                    setPhoneError(true);
                }
                setPhoneNumber(formattedValue);
                break;

            case 'StreetEdit':
                if (value.length < 31) {
                    setStreetError(false);
                } else {
                    setStreetError(true);
                }
                setStreet(value);
                break;

            case 'CityEdit':
                if (value.length < 21) {
                    setCityError(false);
                } else {
                    setCityError(true);
                }
                setCity(value);
                break;

            case 'StateEdit':
                setStateAddress(value);
                onBlurHandler(id);
                break;

            case 'ZipCodeEdit':
                setZipCode(value);
                // if (props.locale === 'en-US') {
                if (props.countryCode === 'US') {
                    if (value.length !== 5) {
                        setZipError(true);
                    } else {
                        if (isNaN(Number(value))) {
                            setZipError(true);
                        } else {
                            setZipError(false);
                        }
                    }
                }
                // if (props.locale === 'en-CA' || props.locale === 'fr-CA') {
                if (props.countryCode === 'CA') {
                    if (value.length !== 7) {
                        setZipError(true);
                    } else {
                        if (Number(value[0]) || isNaN(Number(value[1])) || Number(value[2]) || value[3] !== ' ' ||
                            isNaN(Number(value[4])) || Number(value[5]) || isNaN(Number(value[6]))) {
                            setZipError(true);
                        } else {
                            setZipError(false);
                        }
                    }
                }
                break;
        }
        setFieldError(error ? error : false);
    }, [firstName, firstNameError, lastName, lastNameError, props.countryCode, onBlurHandler]);

    const emailCheckChangeHandler = useCallback(() => {
        setEmailOpt(!emailOpt);
    }, [emailOpt]);

    const emailCheckEventHandler = useCallback((e: any) => {
        const elementColor = getElementColor(e, 'fill');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: strings.OptedIn,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'checkbox',
            eventAction: 'click',
            eventActionResult: emailOpt ? 'uncheck' : 'check',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [emailOpt, props.vehicles, props.selectedVehicle]);

    const phoneCheckChangeHandler = useCallback((e: any) => {
        if (phoneOpt) {
            setPhoneOpt(!phoneOpt);
        } else {
            setDialogActive(true);
        }
        const elementColor = getElementColor(e, 'color');
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: strings.OptedIn,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'checkbox',
            eventAction: 'click',
            eventActionResult: phoneOpt ? 'uncheck' : 'popup',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [phoneOpt, props.vehicles, props.selectedVehicle]);

    const updateHandler = useCallback(() => {
        if (firstName === '' || lastName === '' || !email.match(emailRegex) || phoneNumber === '' || stateAddress === '' ||
            street === '' || zipCode === '' || city === '' || zipError) {
            return;
        }
        // Create customer object to send to pick
        // Don't forget to update optins
        let updatedEmailOpt = '';
        if (emailOpt) {
            updatedEmailOpt = 'Y';
        }
        let updatedPhoneOpt = '';
        if (phoneOpt) {
            updatedPhoneOpt = 'Y';
            if (initialTextOpt === 'I') {
                updatedPhoneOpt = 'I';
            }
            // if (initialTextOpt === 'T') {
            //     updatedPhoneOpt = 'T';
            // }
        } else {
            updatedPhoneOpt = 'M';
            if (initialTextOpt === 'T' || optedOutViaText) {
                updatedPhoneOpt = 'T';
            }
        }
        const strippedPhone = phoneNumber.replace(/[^0-9*]/g, '');
        const updatedCustomer: Customer = {
            nameId: customerInfo!.nameId,
            firstName: firstName,
            lastName: lastName,
            emailAddress: email,
            phoneNumber: strippedPhone,
            emailOptIn: updatedEmailOpt,
            textOptIn: updatedPhoneOpt,
            stateAddress: stateAddress,
            streetAddress: street,
            zipCode: zipCode,
            login: customerInfo!.login,
            prefContact: customerInfo!.prefContact,
            city: city,
            addVehNameId: customerInfo!.addVehNameId,
            gmRedeemAmt: customerInfo!.gmRedeemAmt,
            encryptFirst: customerInfo!.encryptFirst,
            encryptLast: customerInfo!.encryptLast,
            encryptEmail: customerInfo!.encryptEmail,
            encryptPhone: customerInfo!.encryptPhone,
            ascCustId: customerInfo!.ascCustId,
        };
        const apptCustInp: UpdateApptCustInp = {
            nameId: props.apptCust?.custNameId,
            firstName: firstName,
            lastName: lastName,
            emailAddress: email,
            phoneNumber: phoneNumber,
            phoneType: props.apptCust?.custPhoneType,
            prefContact: props.apptCust?.custPrefContact,
            loggedIn: props.apptCust?.custLoggedIn,
        };
        props.onApptCustUpdate(apptCustInp);
        // call PICK
        props.changeCustInfo(updatedCustomer, props.specProfile, props.store, props.branch, props.previewFlag);
        // reset initial values and states for new info
        setEditMode(false);
    }, [firstName, lastName, email, phoneNumber, stateAddress, street, zipCode, city,
        zipError, emailOpt, phoneOpt, customerInfo, props.apptCust?.custNameId,
        props.apptCust?.custPhoneType, props.apptCust?.custPrefContact, props.apptCust?.custLoggedIn,
        props.onApptCustUpdate, props.changeCustInfo, props.specProfile, props.store, props.branch,
        props.previewFlag, initialTextOpt, optedOutViaText]);

    useEffect(() => {
        if (props.changeCustReturned) {
            props.setChangeCustReturned(false);
        }
    }, [props.changeCustReturned, props.errMsg, props.retCode, props.setChangeCustReturned]);

    const mainViewPanes = props.mainPaneViewOrder!.map((view): IView => ({ ...view }));
    const currentViewPanes = mainViewPanes[mainViewPanes.length - 1];

    const cancelHandler = (e: any) => {
        props.popFromMainPane(currentViewPanes.viewId);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: strings.Cancel,
            elementColor: '',
            elementOrder: '',
            elementType: 'footer',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    };

    const closeDialog = useCallback((e: any, text: string) => {
        setDialogActive(false);
        setOptInFail(false);
        let elementColor = '';
        if (text === '') {
            elementColor = getElementColor(e, 'color');
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: text,
            elementColor: elementColor,
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props.vehicles, props.selectedVehicle]);

    // handles setting the phone opt in on a non T value opt-in dialog
    const buttonsHandler = useCallback((e: any, id: string) => {
        if (id === 'yes' && !phoneOpt) {
            setPhoneOpt(true);
        }
        setDialogActive(false);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: id === 'yes' ? strings.Yes : '',
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [phoneOpt, props.vehicles, props.selectedVehicle]);

    // okay will check if user has opted in via text message since they had a T status before
    const okayBtnHandler = useCallback((e: any) => {
        if (props.customerInfo) {
            props.clearTextCheckReturned();
            setCheckingOpt(true);
            props.checkPhoneOptIn(props.customerInfo.nameId, props.specProfile, props.store, props.branch);
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: strings.Okay,
            elementColor: '',
            elementOrder: '',
            elementType: 'scheduling_tool',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'close',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [props?.clearTextCheckReturned,
        props?.customerInfo,
        props?.checkPhoneOptIn,
        props?.specProfile,
        props?.store,
        props?.branch,
        props.vehicles,
        props.selectedVehicle]);

    // handles the opted out via text message dialog and acceptance
    useEffect(() => {
        if (props.textCheckReturned && checkingOpt) {
            setCheckingOpt(false);
            if (props.customerInfo?.textOptIn === 'I') {
                setDialogActive(false);
                setOptedOutViaText(false);
                setPhoneOpt(true);
                setOptInFail(false);
            } else {
                // else if user hasn't opted in yet warn them.
                setOptInFail(true);
            }
        }
    }, [props.textCheckReturned, props.customerInfo, props.clearTextCheckReturned, checkingOpt]);

    let custEmailUpdate = checkCustUpdateEmail(undefined, props.specData);
    if (props.customerInfo?.emailAddress) {
        const bdyEmlUpdate = props.specData?.bdySpecs ? props.specData?.bdySpecs?.custUpdateEml === 'Y' : true;
        const ossEmlUpdate = props.specData?.ossSpecs ? props.specData?.ossSpecs?.custUpdateEml === 'Y' : true;
        const svcEmlUpdate = props.specData?.svcSpecs ? props.specData?.svcSpecs?.custUpdateEml === 'Y' : true;
        custEmailUpdate = bdyEmlUpdate && ossEmlUpdate && svcEmlUpdate;
    }

    const tenDigitPhoneBuilder = function (phone:string) {
        const tenDigit = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;

        return tenDigit;
    };

    const internationPhoneBuilder = function (phone:string) {
        const phoneLength = phone.length;
        const intPhone = `(+${phone.slice(0, phoneLength-10)}) ${phone.slice(phoneLength-10, phoneLength-7)}`+
        `-${phone.slice(phoneLength-7, phoneLength-4)}-${phone.slice(phoneLength-4)}`;

        return intPhone;
    };

    const shortPhoneBuilder = function (phone:string) {
        const phoneLength = phone.length;
        const shortPhone = `${phone.slice(0, phoneLength-7)} ${phone.slice(phoneLength-7, phoneLength-4)}`+
        `-${phone.slice(phoneLength-4, phoneLength)}`;

        return shortPhone;
    };

    let longCode = props.specData?.longCode ?? '';
    if (longCode.length === 10) {
        longCode = tenDigitPhoneBuilder(longCode);
    } else if (longCode.length > 10) {
        longCode = internationPhoneBuilder(longCode);
    } else if (longCode.length && longCode.length < 10) {
        longCode = shortPhoneBuilder(longCode);
    }

    let storeNumber = props.specData?.svcSpecs?.contactPhnNum ?? '';
    if (storeNumber?.length === 10) {
        storeNumber = tenDigitPhoneBuilder(storeNumber);
    } else if (storeNumber.length > 10) {
        storeNumber = internationPhoneBuilder(storeNumber);
    } else if (storeNumber.length && storeNumber.length < 10) {
        storeNumber = shortPhoneBuilder(storeNumber);
    }

    const storeExt = props.specData?.svcSpecs?.contactExt ?? '';
    if (storeExt) {
        storeNumber = storeNumber + ' ext.' + storeExt;
    }

    const btnAreaDiv = classNames(
        css.btnArea,
        {
            [css.btnAreaAcura]: props.theme === 'acura-CA',
        },
    );

    const privacyLinkClass = classNames(
        {
            [css.privacyLinkBMW]: props.theme === 'bmw',
            [css.privacyLinkAcura]: props.theme === 'acura',
        },
    );

    const privacyPolicyLink = props.countryCode === 'US' ? <a href='https://www.reyrey.com/ext/service-portal-policy-2_0'
        target='_blank' rel='noreferrer' className={privacyLinkClass} >{strings.OptIn6} </a>: '';

    const contact = storeNumber === '' ? storeNumber : strings.OptIn4 + storeNumber;
    // dialog for phone opt in if they did not opt out via text
    const notTOptInDialog =
        <Dialog
            cssClasses={{
                content: css.content,
                // contextHeader: css.header,
                paper: css.paper,
                header: css.LightBoxHeader,
            }}
            header={strings.TextOptIn}
            isOpen={dialogActive}
            hideSave
            hideCancel
            onBackDropClick={(e: any) => closeDialog(e, '')}
            onCancel={(e: any) => closeDialog(e, '')}
            noBottomPadding
            width={'full'}
            // noLeftRightPadding={true}
            // customButtons={customButtons}
            onCustomClicked={(e, id) => buttonsHandler(e, id)}
        >
            <div className={css.headerbox}>
                {strings.TextOptIn}
                <div className={css.headerIcon}>
                    <IconRemove id='closeBtn' onClick={(e: any) => closeDialog(e, '')}/>
                </div>
            </div>
            <div>
                <p>{firstName},</p>
                <p className={css.optInMsg}>{strings.OptIn1 + props.specData?.mobileName + strings.OptIn2 +
                    longCode + strings.OptIn3 + props.specData?.mobileName +
                    contact + strings.OptIn5} {privacyPolicyLink}</p>
                <p>{`\n\n` + props.specData?.textOptInMsg}</p>
            </div>
            <div className={css.footer}>
                <hr className={css.horizLine} />
                <div className={btnAreaDiv}>
                    <SVPButton
                        id='No'
                        handler={(e: any) => closeDialog(e, strings.No)}
                        message={strings.No}
                        noArrow
                        variant={'secondaryBtnAlt'}
                        theme={props.theme}
                    />
                    <SVPButton
                        id='yes'
                        handler={(e) => buttonsHandler(e, 'yes')}
                        message={strings.Yes}
                        variant={'primaryBtnAlt'}
                        noArrow
                        theme={props.theme}/>
                </div>
            </div>
        </Dialog>;

    // dialog for phone opt in if they did opt out via text
    const yesTOptInDialog =
        <Dialog
            cssClasses={{
                content: css.content,
                // contextHeader: css.header,
                paper: css.paper,
                header: css.LightBoxHeader,
            }}
            header={strings.TextOptIn}
            isOpen={dialogActive}
            hideSave
            hideCancel
            onBackDropClick={(e) => closeDialog(e, '')}
            onCancel={(e) => closeDialog(e, '')}
            noBottomPadding
            width={'full'}
            // noLeftRightPadding={true}
            // customButtons={customButtons}
            onCustomClicked={(e) => okayBtnHandler(e)}
        >
            {!props.textCheckReturned && checkingOpt ?
                <LoadingProgress cssClasses={{ spinner: css.progressColor }} size={100} /> : null}
            <div className={css.headerbox}>
                {strings.TextOptIn}
                <div className={css.headerIcon}>
                    <IconRemove id='closeBtn' onClick={(e) => closeDialog(e, '')}/>
                </div>
            </div>
            <div>
                <p>{firstName},</p>
                {optInFail ? <p>
                    {strings.ViewAcctOptBackInFail + longCode + strings.ViewAcctOptBackInFail2 + `\n\n`}</p> :
                    <p>{strings.ViewAcctOptBackIn1 + longCode + strings.ViewAcctOptBackIn2 + `\n\n`}</p>}
                <p>{props.specData?.textOptInMsg}</p>
            </div>
            <div className={css.footer}>
                <hr className={css.horizLine} />
                <div className={css.btnAreaOut}>
                    <SVPButton
                        id='No'
                        handler={(e) => closeDialog(e, '')}
                        message={strings.Cancel}
                        noArrow
                        variant={'secondaryBtnAlt'}
                        theme={props.theme}
                    />
                    <SVPButton
                        id='okay'
                        handler={okayBtnHandler}
                        message={strings.Okay}
                        variant={'primaryBtnAlt'}
                        noArrow
                        theme={props.theme}/>
                </div>
            </div>
        </Dialog>;

    const dialogMessage = optedOutViaText ? yesTOptInDialog : notTOptInDialog;

    const disabled = (editMode && (firstName === '' || lastName === '' || !email.match(emailRegex) || stateAddress === '' ||
    (phoneNumber?.replace(/[^0-9]/g, '').length !== 10 && !phoneNumber?.includes('*')) || street === '' || zipCode === '' ||
    city === '' || zipError || fieldError || firstNameError || lastNameError || emailError || cityError || streetError ||
    (firstName + lastName).length > 35));

    const errorCancelHandler = useCallback(() => {
        props.clearError();
        setEmail(initialEmail);
        setEmailCheck(false);
        setErrorUpdateFlag(false);
        setEditMode(true);
    }, [props.clearError, initialEmail]);

    const checkUpdateHandler = useCallback((e: any) => {
        // check if email is used already
        if (email !== initialEmail) {
            props.checkUniqueEmail(email, customerInfo!.nameId, props.specProfile, props.store, props.branch,
                customerInfo!.firstName, customerInfo!.lastName, customerInfo!.phoneNumber);
        } else {
            setErrorUpdateFlag(true);
        }
        setEmailCheck(true);
        setDisplayHelpMessage(false);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: strings.Save,
            elementColor: '',
            elementOrder: '',
            elementType: 'footer',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascFormEngagementInp: ascFormEngagementInput = {
            pageType: 'contact',
            commType: 'form',
            commStatus: 'engage',
            elementText: strings.Save,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'service_appointment',
        };
        ascFormEngagement(ascFormEngagementInp, props.vehicles, props.selectedVehicle);

        const ascFormSubmissionInp: ascFormSubmissionInput = {
            pageType: 'contact',
            commType: 'form',
            commOutcome: 'crm_update',
            submissionId: customerInfo?.ascCustId! ?? '',
            elementText: strings.Save,
            department: 'service',
            formName: 'Service_Portal_2',
            formType: 'consumer_contact',
        };
        ascFormSubmission(ascFormSubmissionInp, props.vehicles, props.selectedVehicle);
        // if we are fine then we update as normal else we display error message
    }, [props.checkUniqueEmail, email, initialEmail, customerInfo, props.specProfile,
        props.store, props.branch, props.vehicles, props.selectedVehicle]);

    const updateInfoBtnHandler = useCallback((e: any) => {
        setEditMode(!editMode);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'contact',
            elementText: editMode ? strings.Save : strings.UpdateInfo,
            elementColor: '',
            elementOrder: '',
            elementType: 'footer',
            elementSubType: 'nav_button',
            eventAction: 'click',
            eventActionResult: 'next_step',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [editMode, props.vehicles, props.selectedVehicle]);

    const errorUpdateHandler = useCallback(() => {
        // if we are fine then we update as normal else we display error message
        setEmail(initialEmail);
        setErrorUpdateFlag(true);
    }, [initialEmail]);

    useEffect(() => {
        if (emailCheck && (errorUpdateFlag || props.errMsg==='0000')){
            updateHandler();
            setErrorUpdateFlag(false);
            props.clearError();
            setEmailCheck(false);
        }
    }, [props.clearError, props.errMsg, emailCheck, errorUpdateFlag, updateHandler]);

    const recordLockTryAgain = useCallback((e: any) => {
        props.clearError();
        checkUpdateHandler(e);
    }, [props.clearError, checkUpdateHandler]);

    const error = useMemo(() => {
        let errMsg = props.errMsg;
        if (props.retCode === '3') {
            errMsg = '3';
        }
        if (props.retCode === '1009') {
            errMsg = '1009';
        }
        if (errMsg && errMsg !== '0000') {
            if (errMsg === '3') {
                return GetErrorMessage(errMsg, recordLockTryAgain, errorCancelHandler, errorCancelHandler, email);
            }

            return GetErrorMessage(errMsg, errorUpdateHandler, errorCancelHandler, errorCancelHandler, email);
        }

        return null;
    }, [props.errMsg, props.retCode, email, errorUpdateHandler, errorCancelHandler, recordLockTryAgain]);

    const optInBlockClasses = classNames(
        css.optInBlock,
        {
            [css.disabledColor]: !editMode,
        },
    );

    const NameStyles = classNames(
        css.Name,
        {
            [css.NameBMW]: props.theme === 'bmw',
            [css.NameMazda]: props.theme === 'mazda',
            [css.NameGenesis]: props.theme === 'genesis',
        },
    );

    return (
        <div>
            <ScrollBar scrollVertical>
                <div className={css.mainDiv}>
                    {error}
                    <h2 className={NameStyles}>{firstName + ','}</h2>
                    <h3>{strings.HereProfile}</h3>
                    <hr />
                    {/* Link to change fields to edit */}
                    <div className={css.fieldsDiv}>
                        <div className={css.firstHalf}>
                            {/* First Name */}
                            <div>
                                <div className={css.infoMargin}>
                                    <TextField
                                        id='FirstNameEdit'
                                        value={firstName}
                                        type='text'
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler}
                                        disabled={!editMode}
                                        label={strings.FirstName}
                                        required
                                        size='full'
                                        disableUnderline={!editMode}
                                        error={firstNameError}
                                        helperText={(firstNameError || lastNameError) ? strings.ValidNameLength : ''}
                                    />
                                </div>
                            </div>
                            {/* Last Name */}
                            <div>
                                <div className={css.infoMargin}>
                                    <TextField
                                        id='LastNameEdit'
                                        value={lastName}
                                        type='text'
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler}
                                        label={strings.LastName}
                                        disabled={!editMode}
                                        required
                                        size='full'
                                        disableUnderline={!editMode}
                                        error={lastNameError}
                                        helperText={lastNameError || firstNameError ? strings.ValidNameLength : ''}
                                    />
                                </div>
                            </div>
                            {/* Email | checkbox (only editable if spec is set to allow) */}
                            <div className={css.checkboxBlocks}>
                                <div className={css.infoLine}>
                                    <TextField
                                        id='EmailEdit'
                                        value={email}
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler}
                                        size='full'
                                        label={strings.EmailAddress}
                                        type='email'
                                        disabled={!editMode || !custEmailUpdate}
                                        required
                                        disableUnderline={!editMode}
                                        error={emailError}
                                        helperText={emailError ? emailErrorMsg: ''}
                                    />
                                </div>
                                <div className={optInBlockClasses}>
                                    <h6>{strings.OptedIn}</h6>
                                    <div className={css.checkboxPadding}>
                                        <div onClick={(e) => emailCheckEventHandler(e)}>
                                            <Checkbox
                                                id='EmailCheck'
                                                checked={emailOpt}
                                                disabled={!editMode}
                                                variant={'primaryCkb'}
                                                onChange={emailCheckChangeHandler}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Phone | checkbox*/}
                            <div className={css.checkboxBlocks}>
                                <div className={css.infoLinePhone}>
                                    <TextField
                                        id='PhoneEdit'
                                        value={phoneNumber}
                                        type='tel'
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler}
                                        size='full'
                                        label={strings.PhoneNumber}
                                        disabled={!editMode}
                                        error={phoneError}
                                        helperText={phoneError ? strings.ValidPhone : ''}
                                        disableUnderline={!editMode}
                                    />
                                </div>
                                {props.specData?.smsLaunched === 'Y'?<div className={optInBlockClasses}>
                                    <h6>{strings.OptedIn}</h6>
                                    <div className={css.checkboxPadding}>
                                        <Checkbox
                                            id='PhoneCheck'
                                            checked={phoneOpt}
                                            disabled={!editMode}
                                            onChange={phoneCheckChangeHandler}
                                            variant={'primaryCkb'}
                                        />
                                    </div>
                                    <span className={css.gridQuestion}>
                                        <div className={helpDisplay}>
                                            <IconButton
                                                id='HelpBtn'
                                                onClick={(e: any) => onHelpClick(e)}
                                                variant={'help'}>
                                                <div className={css.question}>
                                                    <IconHelpCircle />
                                                </div>
                                            </IconButton>
                                        </div>
                                        <div id='helpMini' className={helpDisplayMini}>
                                            <IconButton
                                                id='HelpBtnMini'
                                                onClick={(e: any) => onHelpClick(e)}
                                                variant={'help'}>
                                                <div className={css.question}>
                                                    <IconHelpCircleAlt />
                                                </div>
                                            </IconButton>
                                        </div>
                                    </span>
                                </div>: null}
                            </div>
                            {
                                displayHelpMessage ?
                                    <div style={{ display: 'block', marginTop: '1rem' }}>
                                        <div>
                                            <small>
                                                {props.specData?.textOptInMsg}{' '}{privacyPolicyLink}
                                            </small>
                                        </div>
                                    </div> :
                                    null
                            }
                        </div>
                        <div className={css.secondHalf}>
                            {/* street */}
                            <div>
                                <div className={css.infoMargin}>
                                    <TextField
                                        id='StreetEdit'
                                        value={street}
                                        type='text'
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler}
                                        label={strings.StreetAddress}
                                        disabled={!editMode}
                                        required
                                        size='full'
                                        disableUnderline={!editMode}
                                        error={streetError}
                                        helperText={streetError ? strings.ValidStreet : ''}
                                    />
                                </div>
                            </div>
                            {/* city */}
                            <div>
                                <div className={css.infoMargin}>
                                    <TextField
                                        id='CityEdit'
                                        value={city}
                                        type='text'
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler}
                                        label={strings.City}
                                        disabled={!editMode}
                                        required
                                        size='full'
                                        disableUnderline={!editMode}
                                        error={cityError}
                                        helperText={cityError ? strings.ValidCity : ''}
                                    />
                                </div>
                            </div>
                            {/* state */}
                            <div>
                                <div id='selectList' className={css.infoMargin}>
                                    {!editMode ?
                                        <TextField
                                            id='StateEdit'
                                            type='text'
                                            value={getStateOrProvinceName(props.locale, stateAddress)}
                                            onChange={onChangeHandler}
                                            label={strings.State}
                                            disabled={!editMode}
                                            required
                                            size='full'
                                            disableUnderline={!editMode}
                                        /> :
                                        <SelectList
                                            id='StateEdit'
                                            classNames={css.selectList}
                                            dropDownList={stateList}
                                            onChange={onChangeHandler}
                                            value={stateAddress}
                                            disabled={!editMode}
                                            label={strings.State}
                                            size='full'
                                            required
                                            key={selectListKey}
                                        />
                                    }
                                </div>
                            </div>
                            {/* zip */}
                            <div>
                                <div className={css.infoMargin}>
                                    <TextField
                                        id='ZipCodeEdit'
                                        type={props.countryCode === 'US' ? 'tel' : 'text'}
                                        value={zipCode}
                                        onChange={onChangeHandler}
                                        onBlur={onBlurHandler}
                                        size='full'
                                        label={strings.ZipCode}
                                        disabled={!editMode}
                                        required
                                        error={zipError}
                                        disableUnderline={!editMode}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollBar>
            {/* Footer with Cancel and Update Buttons */}
            <Footer
                id='footer'
                handler={editMode ? checkUpdateHandler : updateInfoBtnHandler}
                message={editMode ? strings.Save : strings.UpdateInfo}
                secondaryMessage={strings.Cancel}
                secondaryhandler={cancelHandler}
                isDisabled={disabled}
                theme = {props.theme}/>
            {dialogMessage}
        </div>
    );
};

function GetErrorMessage(
    message: string,
    updateBtnHandler: (e: any) => void,
    cancelBtnHandler: () => void,
    closeHandler: () => void,
    email: string) {
    let headerMsg = '';
    let errorMsg = '';
    let primaryMessage = '';
    let secondaryMessage = '';
    let primaryHandler = updateBtnHandler;
    let secondaryHandler = cancelBtnHandler;
    const messageMode = strings.MessageUpdating;

    switch (message) {
        case '3':
            return <RecordLockError
                message={messageMode + strings.AcctTimeLit}
                headerMsg={strings.Oops}
                primaryHandler={updateBtnHandler}
                secondaryHandler={cancelBtnHandler}
                closeHandler={closeHandler}
            />;
        case '1009':
            headerMsg = strings.Oops;
            errorMsg = strings.ChangeInfoErrMsg;
            primaryMessage = strings.OkLit.toUpperCase();
            primaryHandler = cancelBtnHandler;
            break;
        case '1007':
        default:
            headerMsg = strings.EmailUsed;
            errorMsg = strings.formatString(strings.EmailUsedMsg, email).toString();
            primaryMessage = strings.Update;
            secondaryMessage = strings.Cancel;
            primaryHandler = updateBtnHandler;
            secondaryHandler = cancelBtnHandler;
            break;
    }

    return (
        <ErrorMessage
            headerMsg={headerMsg}
            errorMsg={errorMsg}
            primaryBtnMessage={primaryMessage}
            secondaryBtnMessage={secondaryMessage ?? undefined}
            primaryHandler={primaryHandler}
            secondaryHandler={secondaryHandler ?? undefined}
            closeHandler={closeHandler}
        />
    );
}

export default ViewAccount;